import { combineReducers } from "redux";
import publications from "./publications";
import blogs from "./blogs";
import resources from "./resources";
import projects from "./projects";
import fireaustralia from "./fireaustralia";
import researchbriefings from "./researchbriefings";
export default combineReducers({publications,blogs,resources,projects,fireaustralia,researchbriefings})